<div role="group" class="example-tel-input-container" 
     [formGroup]="parts"
     [attr.aria-labelledby]="_formField?.getLabelId()"
     (focusin)="onFocusIn($event)"
     (focusout)="onFocusOut($event)">
     <span class="example-tel-input-spacer">&#40;</span>
  <input class="example-tel-input-element"
         formControlName="area" size="4"
         maxLength="4"
         aria-label="Area code"
         (input)="_handleInput(parts.controls.area, exchange)"
         placeholder="1234"
         #area>
  <span class="example-tel-input-spacer">&#41;</span>
  <input class="example-tel-input-element"
         formControlName="exchange"
         maxLength="3"
         size="3"
         aria-label="Exchange code"
         (input)="_handleInput(parts.controls.exchange, subscriber)"
         (keyup.backspace)="autoFocusPrev(parts.controls.exchange, area)"
         placeholder="123"
         #exchange>
  <!-- <span class="example-tel-input-spacer">&ndash;</span> -->
  <input class="example-tel-input-element"
         formControlName="subscriber"
         maxLength="3"
         size="3"
         aria-label="Subscriber number"
         (input)="_handleInput(parts.controls.subscriber)"
         (keyup.backspace)="autoFocusPrev(parts.controls.subscriber, exchange)"
         placeholder="123"
         #subscriber>
</div>
